function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
let _ = (t)=>t, t;
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */ import { css, Global } from '@emotion/react';
import React, { useEffect } from 'react';
const ESCAPE_KEY_CODE = 27;
const ESCAPE_KEY = 'Escape';
function ClickOutside(_0) {
    let { as: Tag = 'span', children, enabled = true, onClick, onEscape, toggleElementRef } = _0, rest = _object_without_properties(_0, [
        "as",
        "children",
        "enabled",
        "onClick",
        "onEscape",
        "toggleElementRef"
    ]);
    const wrapperRef = React.useRef(null);
    useEffect(()=>{
        if (!enabled) return;
        const handleKeyDown = (event)=>{
            if (event.key === ESCAPE_KEY || event.keyCode === ESCAPE_KEY_CODE) {
                if (typeof onEscape === 'function') {
                    onEscape();
                } else if (typeof onClick === 'function') {
                    onClick();
                }
            }
        };
        const handleClick = (event)=>{
            const isOutsideContainer = !contains(wrapperRef.current, event.target);
            if (isOutsideContainer && onClick) {
                if (toggleElementRef) {
                    const isOutsideToggleElement = !contains(toggleElementRef === null || toggleElementRef === void 0 ? void 0 : toggleElementRef.current, event.target);
                    if (isOutsideToggleElement) {
                        onClick();
                    }
                } else {
                    onClick();
                }
            }
        };
        window.addEventListener('mousedown', handleClick);
        window.addEventListener('keydown', handleKeyDown);
        document.body.classList.add('fab-click-outside-active');
        return ()=>{
            window.removeEventListener('mousedown', handleClick);
            window.removeEventListener('keydown', handleKeyDown);
            document.body.classList.remove('fab-click-outside-active');
        };
    }, [
        onClick,
        onEscape,
        toggleElementRef,
        enabled
    ]);
    return /*#__PURE__*/ _jsxs(Tag, _object_spread_props(_object_spread({}, rest), {
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ _jsx(Global, {
                styles: css(t || (t = _`
          @supports (-webkit-overflow-scrolling: touch) {
            .fab-click-outside-active {
              // fix event bubbling for iOS hack on <body />
              cursor: pointer;
              -webkit-tap-highlight-color: transparent;
            }
          }
        `))
            }),
            children
        ]
    }));
}
function contains(element, target) {
    return element && target && element.contains(target);
}
export default ClickOutside;
